import(/* webpackMode: "eager" */ "/backpine-learning/app/global-error.tsx")